var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-subtitle-2 font-weight-bold"},[_vm._v(_vm._s(_vm.getItemData.riskAssRoleNm))])])}
var staticRenderFns = []

export { render, staticRenderFns }